/**
 * 레거시 전역 스크립트 — `public/dist/legacy.js`
 *
 * 구 `public/js/common.js` 를 번들로 옮긴 것. 진입점 24곳이 이 파일 하나를 싣는다.
 *
 * [왜 아직 전역인가]
 * blade 인라인 <script> 448건과 onclick 류 인라인 핸들러 속성 625건이 이 이름들을
 * 전역으로 부른다. `import` 로 바꾸려면 그 1,073곳을 먼저 걷어내야 해서, 그때까지는
 * **맨 아래에서 window 로 다시 내보낸다.**
 *
 * [Util 을 여기서 세우는 이유]
 * 아래 함수 상당수가 `$j.Common.Util` 로 위임하는데, 진입점 24곳 중 7곳은
 * main.js(4.5MB)를 싣지 않는 단독 문서다(로그인·정산·출금심사 등).
 * 그 7곳에도 $j 가 있어야 하므로 여기서 최소한만 세운다.
 * main.js 가 함께 실리는 페이지에서는 app.js 가 `window.$j = {}` 로 새로 만들며
 * 같은 클래스로 다시 채운다 — 순서에 관계없이 결과가 같다.
 *
 * ⚠ `G5` 전역은 여기서 만들지 않는다. `/asset/bootstrap`(App\Common\ClientBootstrap)이 만든다.
 *   이 파일의 함수들은 G5 를 호출 시점에 참조하므로 선후는 상관없다.
 *
 * @see resources/js/app.js            main.js 쪽 $j 구성
 * @see app/Common/ClientBootstrap.php G5 전역
 */
import Util from './Common/Util';
import Store from './Common/Store';
import Form  from './Common/Form';

window.$j = window.$j || {};
$j.Common = $j.Common || {};
$j.Common.Util = Util;
$j.Common.Store = Store;
$j.Common.Form  = Form;

// ⚠ `G5` 전역은 여기서 만들지 않는다. **`/asset/bootstrap`(App\Common\ClientBootstrap)이 만든다.**
//
//   - 코드표(ORDER_STATUS·MEMBER_STATUS·CARTYPE_KR·HOW_TO_PAY·SIGN_DUE)와 기종표(CARMASTER)
//   - 클라 상수(MAP_ID·DEBOUNCE_TIME·CK_*·LS_*·EDITOR_*·NS)
//
// 예전엔 이 파일이 `const G5 = {…}` 로 만들고 bootstrap 이 덮어썼다. 주인이 둘이라
// 로딩 순서에 묶였고, 무엇보다 이 파일을 폐기할 수가 없었다.
// 값을 고칠 일이 있으면 app/G5/config.php 또는 ClientBootstrap 을 고친다.
//
// 이 파일의 함수들은 G5 를 **호출 시점에** 참조하므로 bootstrap 과의 선후는 상관없다.
// 다만 두 스크립트는 항상 짝으로 실린다(진입점 24곳).

// 직접 debounce 함수
/** 구현은 `$j.Common.Util.debounce` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function debounce(fn, delay=0){ return $j.Common.Util.debounce(fn, delay); }
/** 구현은 `$j.Common.Util.nvl` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function nvl(value, defaultValue=''){ return $j.Common.Util.nvl(value, defaultValue); }

/** 구현은 `$j.Common.Util.int` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function int(val){ return $j.Common.Util.int(val); }

// 정산 날짜 입력 Mobiscroll 달력 (레거시 iframe 달력 대체)
/**
 * 숫자에 세자리마다 콤마
 * @param num
 * @returns {string | string}
 */
/** 구현은 `$j.Common.Util.formatNumber` */
function number_format(num){ return $j.Common.Util.formatNumber(num); }


/** 구현은 `$j.Common.Util.number_to_withzero` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function number_to_withzero(num,n){ return $j.Common.Util.number_to_withzero(num, n); }

//010-5651-6104
/* ─────────────────────────────────────────────────────────────
 * 쿠키 전역함수 — 정본은 $j.Common.Store.cookie (resources/js/Common/Store.js).
 * 아래 셋은 호환용 얇은 위임 래퍼다. 신규 코드는 $j.Common.Store.cookie 를 직접 쓸 것.
 * ($j 로드 전(dist 미로드) 호출 대비 폴백 구현을 함께 둔다.)
 * ───────────────────────────────────────────────────────────── */

/**
 * 쿠키 설정
 * @param name 쿠키의 이름
 * @param value 쿠키의 값
 * @param days 쿠키의 만료 기간 (일 단위, 숫자)
 */
/** 구현은 `$j.Common.Store.cookie.set` */
function setCookie(name, value, days) {
	return $j.Common.Store.cookie.set(name, value, days ? { days } : {});
}

/**
 * 쿠키 조회
 * @param name
 * @returns {null|string}
 */
/** 구현은 `$j.Common.Store.cookie.get` */
function getCookie(name) {
	return $j.Common.Store.cookie.get(name);
}

/**
 * 쿠키삭제
 * @param name
 */
/** 구현은 `$j.Common.Store.cookie.remove` */
function deleteCookie(name) {
	return $j.Common.Store.cookie.remove(name);
}

/** 구현은 `$j.Common.Util.render_template` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function render_template(tpl, row){ return $j.Common.Util.render_template(tpl, row); }


/** 구현은 `$j.Common.Util.nl2br` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function nl2br(str){ return $j.Common.Util.nl2br(str); }

/** 구현은 `$j.Common.Util.getHost` */
function getHost(){ return $j.Common.Util.getHost(); }

/** 구현은 `$j.Common.Util.coNumber` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function coNumber(num){ return $j.Common.Util.coNumber(num); }
/** 구현은 `$j.Common.Util.formatDateTime` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function formatDateTime(dt){ return $j.Common.Util.formatDateTime(dt); }

/** 구현은 `$j.Common.Util.phoneNumber` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function phoneNumber(value){ return $j.Common.Util.phoneNumber(value); }


/** 구현은 `$j.Common.Util.getSimpleDateTime` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function getSimpleDateTime(datetime){ return $j.Common.Util.getSimpleDateTime(datetime); }

/**
 * 알럿·확인창 간편호출 ($j.Ui.Dialog 로 위임된다 — .ai/frontend.md)
 * swalert('타이틀');
 * swalert(['타이틀','아이콘']);
 * swalert(['타이틀','아이콘','본문']);
 * swalert(['타이틀','아이콘','본문'], function(){ });
 * swalert('타이틀', function(){ });
 * swalert('타이틀', function(){ }, ['예','아니오']);
 * swalert('타이틀', function(){ }, ['예','아니오'],function(){});
 * @param param1 제목 또는 [제목,아이콘,본문] 배열
 * @param param2 confirm 핸들러
 * @param param3 버튼배열
 * @param param4 deny 핸들러
 */
/**
 * SweetAlert2 래퍼 — **구현은 `$j.Common.Util.swalert`** 에 있다.
 * 여기 남는 이유: blade 인라인·onclick 이 전역 이름으로 부른다(1,800곳 가까이).
 */
function swalert(param1, param2=null, param3=null, param4=null){
	return $j.Common.Util.swalert(param1, param2, param3, param4);
}

/** 구현은 `$j.Common.Util.isSosokSamsung` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function isSosokSamsung(code){ return $j.Common.Util.isSosokSamsung(code); }
/** 구현은 `$j.Common.Util.isSosokJbbuller` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function isSosokJbbuller(code){ return $j.Common.Util.isSosokJbbuller(code); }
/** 구현은 `$j.Common.Util.getParentSosokCode` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function getParentSosokCode(code, type){ return $j.Common.Util.getParentSosokCode(code, type); }


/** 구현은 `$j.Common.Util.decodeMemberBank` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function decodeMemberBank(str){ return $j.Common.Util.decodeMemberBank(str); }


/** 구현은 `$j.Common.Util.getImageUrl` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function getImageUrl(path, host, size='original'){ return $j.Common.Util.getImageUrl(path, host, size); }

/** 구현은 `$j.Common.Util.isSocialId` — 전역 이름은 blade·레거시 호출부 때문에 남긴다 */
function isSocialId(mem_id){ return $j.Common.Util.isSocialId(mem_id); }

// ─────────────────────────────────────────────────────────────────────
// 전역 재노출 — blade 인라인·onclick 이 이 이름으로 부른다.
// 호출부를 걷어낼 때마다 여기서 한 줄씩 지우면 된다.
// ─────────────────────────────────────────────────────────────────────
Object.assign(window, {
    debounce,
    nvl,
    int,
    number_format,
    number_to_withzero,
    setCookie,
    getCookie,
    deleteCookie,
    render_template,
    nl2br,
    getHost,
    coNumber,
    formatDateTime,
    phoneNumber,
    getSimpleDateTime,
    swalert,
    isSosokSamsung,
    isSosokJbbuller,
    getParentSosokCode,
    decodeMemberBank,
    getImageUrl,
    isSocialId,
});
